import _ from 'underscore';

export module UsernameHelpers {

  export function splitUsernames(usernamesText: string): string[] {
    return _.chain(usernamesText.split(/[;,\r\n]+/))
            .map((username: string) => username.trim())
            .compact() // Remove empty strings
            .unique()  // Remove dupes
            .value();
  }

}
